<template>
    <div class="container"  v-if="projectData && projectData.length">
        <div v-if="!selectedProject" class="project-list-header action-buttons">
            <div class="project-title-col">Projets </div>
            <div class="projects-after-validation-col" :class="{ active: currentProjectFilter == 'validation' }" v-if="selectedReferential > 0 && getProjectsInValidationList.length > 0" @click="currentProjectFilter = 'validation'">En validation</div>
            <div class="projects-after-validation-col" :class="{ active: currentProjectFilter == 'editing'}" v-if="selectedReferential > 0 && getProjectsBackInEditionList.length > 0" @click="currentProjectFilter = 'editing'">Remis en édition </div>
            <div class="projects-after-validation-col" :class="{ active: currentProjectFilter == 'validated'}" v-if="selectedReferential > 0 && getProjectsValidatedList.length > 0" @click="currentProjectFilter = 'validated'">Validés</div>
            <div class="projects-after-validation-col" :class="{ active: currentProjectFilter == 'archive'}" v-if="selectedReferential > 0 && getProjectsInArchivedList.length > 0" @click="currentProjectFilter = 'archive'">Archivés</div>
            </div>
        <div class="project-list">
            <div 
                v-for="project in filterProjects(currentProjectFilter)" 
                :key="project.project_id" 
                class="project-item"
                @click="selectProject(project)"
            >
                <div class="project-title-col">{{ project.title }}</div>
                <div class="actions-col"
                >
                    <button 
                      v-if="project.status === 'ARCHIVE' && isAdmin"
                      @click.stop="deleteProject(project.project_id)" 
                      title="Supprimer le projet"
                      class="btn btn-icon"
                      ><i class="bi bi-trash3-fill"></i></button>
                    <button 
                      v-if="project.status !== 'ARCHIVE'"
                      @click.stop="changeProjectStatus(project.project_id, 'ARCHIVE')" 
                      title="Archiver le projet" 
                      class="btn btn-icon"
                      ><i class="bi bi-trash3-fill"></i></button>
                    <!-- <button 
                      v-if="project.status === 'ARCHIVE'"
                      @click.stop="changeProjectStatus(project.project_id, 'EDITING')" 
                      title="Restaurer projet en édition" 
                      class="btn btn-icon"  
                      ><i class="bi bi-rewind"></i></button>
                    <button 
                      v-if="project.status === 'ARCHIVE'"
                      @click.stop="changeProjectStatus(project.project_id, 'VALIDATION')" 
                      title="Restaurer projet en validation" 
                      class="btn btn-icon"
                      ><i class="bi bi-rewind"></i></button> -->
                    <div v-if="selectedProject > 0" class="action-buttons">
                      <button v-if="project.status === 'EDITING' && selectedProject > 0 && project.PC" @click.stop.prevent="changeProjectStatus('VALIDATION')" class="create-button">Remise en évaluation</button>
                      <button v-if="project.status === 'VALIDATION' && selectedProject > 0 && project.PE" @click.stop.prevent="changeProjectStatus('EDITING')" class="create-button">Remise en édition</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Access management UI, only if a project is selected -->
        <div v-if="selectedProject">
            <h1>Gestion des évaluateurs du projet</h1>
            <br>
            <br>
            <div class="card flex">
                <input 
                    @input="searchUser"
                    v-model="searchString" 
                    type="text" 
                    placeholder="Ajouter un évaluateur" 
                    class="p-inputtext-sm p-d-block p-mb-2"/>
            </div>
            <DataTable v-if="searchString" :value="filteredUsers || []" :paginator="false" rowKey="user_id">
                <Column field="editor" header="Évaluateur" :sortable="true">
                    <template #body="slotProps">
                        <input 
                            :key="`projectAccess-${slotProps.data.user_id}`"
                            @change="toggleSelected(slotProps.data, 'PE', $event.target.checked)" 
                            :checked="slotProps.data.PE"
                            type="checkbox" />
                    </template>
                </Column>
                <Column field="name" header="Nom" :sortable="true" />
                <Column field="surname" header="Prénom" :sortable="true" />
                <Column field="username" header="Nom utilisateur" :sortable="true">
                    <template #body="slotProps">
                        <span>{{ slotProps.data.username }}</span>
                        <i v-if="slotProps.data.admin === 1" class="bi bi-shield-fill" title="admin"></i>
                    </template>
                </Column>
                <Column field="email" header="Email" :sortable="true" />
            </DataTable>
            <br>
            <br>
            <DataTable :value="getUsersWithAccessProject || []" :paginator="false" dataKey="user_id" rowKey="user_id">
                <Column field="editor" header="Évaluateur" :sortable="true">
                    <template #body="slotProps">
                        <input
                            :key="`projectAccess-${slotProps.data.user_id}`"
                            @change="toggleSelected(slotProps.data, 'PE', $event.target.checked)" 
                            :checked="slotProps.data.PE"
                            :disabled="lastOne(getUsersWithAccessProject)"
                            type="checkbox" />
                    </template>
                </Column>
                <Column field="name" header="Nom" :sortable="true" />
                <Column field="surname" header="Prénom" :sortable="true" />
                <Column field="username" header="Nom utilisateur" :sortable="true">
                    <template #body="slotProps">
                        <span>{{ slotProps.data.username }}</span>
                    </template>
                </Column>
                <Column field="email" header="Email" :sortable="true" />
            </DataTable>
            <button class="back-button" @click="deselectProject">Retour</button>
        </div>
    </div>
    <ConfirmationDialog v-if="canEditList.confirmationDialogOpen" />
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import '../../assets/styles/base.css';
import '../../assets/styles/multiselect.css';
import ConfirmationDialog from '../generic/ConfirmationDialog.vue'

export default {
    name: "ProjectAccess",
    components: {
        DataTable,
        Column,
        ConfirmationDialog,
    },
    data() {
        return {
            searchString: "",
            selectedProject: null,
            filteredUsers: [],
            currentProjectFilter: null,
        }
    },
    computed: {
        ...mapState('referential', ['selectedReferential', 'userList', 'userListRightsProject', 'projectStatusByReferential', 'loading']),
        ...mapState('project', ['canEditList', 'projectData', 'loading']),
        ...mapState('auth', ['isAdmin']),
        ...mapGetters("referential", [/* "getProjectsInValidation", */ "getProjectsInValidationList", /* "getProjectsValidated", */ "getProjectsValidatedList"/* , "getProjectsInArchived" */, "getProjectsInArchivedList",/*  "getProjectsBackInEdition", */ "getProjectsBackInEditionList", "getUsersWithAccessProject", "usersWithoutProjectAccess",/* "getProjectsInPastValidationList" */]),

    },
    mounted() {
        this.$store.dispatch("project/fetchProjectList")
        this.$store.dispatch("referential/projectStatus", {id: this.$route.params.id})
        //     .catch(error => console.error("Error fetching referential data:", error))
        //console.log("Mounted ProjectAccess component")
        this.checkRouteParams()
        //console.log("Selected referential:", this.selectedReferential)
        //console.log("Route params found, setting selectedReferential to:", this.$route.params)
        this.isReady = true
        this.isReady = true
        if(this.selectedReferential === 0) {
            // if(this.$route.params.referentialId) {
            //     this.$store.commit("project/selectProjectMutation", this.$route.params.projectId)
            // }
        } else {
            //console.log("Referential already loaded")
        }
        // this.loadUsers().then(() => {
            //console.log("User list loaded", this.userList)
            //console.log("Selected users with access", this.usersWithAccess)
            //console.log("Selected users without access", this.usersWithoutAccess)
            
        // }).catch((error) => {
        //     console.error("Error loading user list:", error)
        // })
    },
    watch: {
        selectedProject(newVal) {
            if (newVal) {
                //console.log("Selected project changed to:", newVal)
                this.loadUsers()
            }
        },
        getProjectsInValidationList: {
            handler() {
                this.syncCurrentProjectFilter()
            },
            immediate: true
        },
        getProjectsBackInEditionList: {
            handler() {
                this.syncCurrentProjectFilter()
            },
            immediate: true
        },
        getProjectsValidatedList: {
            handler() {
                this.syncCurrentProjectFilter()
            },
            immediate: true
        },
        getProjectsInArchivedList: {
            handler() {
                this.syncCurrentProjectFilter()
            },
            immediate: true
        },
    },
    methods: {
        getDefaultProjectFilter() {
            if (this.getProjectsInValidationList?.length > 0) return "validation"
            if (this.getProjectsBackInEditionList?.length > 0) return "editing"
            if (this.getProjectsValidatedList?.length > 0) return "validated"
            if (this.getProjectsInArchivedList?.length > 0) return "archive"
            return "validation"
        },
        syncCurrentProjectFilter() {
            const nextFilter = this.getDefaultProjectFilter()
            if (this.currentProjectFilter !== nextFilter) {
                this.currentProjectFilter = nextFilter
            }
        },
        lastOne(data){
            if(data.length <= 1)return true;
            else false
        },
        async checkRouteParams() {
            if(!this.projectStatusByReferential) await this.$store.dispatch("referential/fetchReferentialList")
            //console.log("Route params found, setting selectedReferential to:", this.$route.params)
            if(this.$route.params.referentialId) {
                //console.log("Setting selectedReferential to:", this.$route.params.referentialId)
                if(this.$route.params.referentialId !== this.selectedReferential) {
                    await this.$store.dispatch("referential/fetchReferentialList")
                    //console.log("Dispatching actions to fetch referential data for ID:", this.$route.params.referentialId)
                    //    .catch(error => console.error("Error fetching referential data:", error))
                    // this.$store.dispatch("referential/fetchCriteriaListFromReferential", { id: this.$route.params.referentialId})
                    // this.$store.dispatch("referential/projectStatus", { id: this.$route.params.referentialId });
                } else {
                    // //console.log("Referential already selected, no need to fetch again")
                }
            } else {
                // this.$store.commit("referential/selectTreeMutation", 0)
            }   
        },
        selectProject(project) {
            //console.log("Selecting project:", project)

            const id = project.project_id
            if(this.selectedProject === id) {
                this.deselectProject()
                //console.log("deselectProject")
                // this.$store.commit("project/validatorListMutation", [])
                // this.$store.commit("project/projectStatusMutation", [])
                return
            }
            //console.log("selection done")
            this.selectedProject = id
        },
        deselectProject() {
            this.selectedProject = null
            this.filteredUsers = []
            this.searchString = ""
        },
        checkAccessForUser(user, type) {
            if(type === "PE") {
                //console.log("Checking PE access for user", user.PE)
                return user.PE
            }
            console.error("We got no user yet, so we need to check what is inside user", user)
            return false
        },
        toggleSelected(user, type, checked) {
            //console.log("Toggling access for user", user, "type", type, "checked", checked)
            this.$store.dispatch("referential/toggleProjectAccess", { user: user, project_id: this.selectedProject, type: type, checked: checked })
            .then(() => {
                this.searchUser()
            })
        },
        async loadUsers() {
            //console.log("loadUsers called")
            if(!this.selectedProject) {
                console.error("No project selected, cannot load users")
                return
            }
            await this.$store.dispatch("referential/fetchValidatorList", { id: this.selectedProject })
                .then(() => {
                    //console.log("User list loaded", this.userList)
                    //console.log("User rights", this.userListRightsProject)
                })
                .catch((error) => {
                    console.error("Error loading user list:", error)
                })
            await this.$store.dispatch("referential/fetchUserList", this.selectedReferential)
                .then(() => {
                    //console.log("User list loaded", this.userList)
                    //console.log("User rights", this.userListRightsReferential)
                    //console.log("User rights", this.userListRightsReferential)
                })
                .catch((error) => {
                    console.error("Error loading user list:", error)
                })
        },
        searchUser() {
            setTimeout(() => {
                //console.log("searchUser called with event: ", event)
                //console.log("searchString: ", this.searchString)
                if(!this.searchString.trim().length || this.searchString.trim().length <= 2) {
                    // this.filteredUsers.value = [...this.usersWithoutAccess]
                    this.filteredUsers = []
                    //console.log("returning :", this.filteredUsers)
                } else {
                    //console.log("Filtering users with query: ", this.searchString)
                    this.filteredUsers = this.usersWithoutProjectAccess.filter((user) => {
                        return user.name.toLowerCase().includes(this.searchString.toLowerCase()) || user.surname.toLowerCase().includes(this.searchString.toLowerCase()) || user.email.toLowerCase().includes(this.searchString.toLowerCase()) || user.username.toLowerCase().includes(this.searchString.toLowerCase())
                    })
                    //console.log("Filtered users: ", this.filteredUsers)
                }
            }, 250)
        },
        filterProjects(status) {
            //console.log("filterProjects called with status:", status, "and selectedProject:", this.selectedProject)
            if(this.selectedProject && this.selectedProject > 0) {
                //console.log("A specific project is selected, returning only that project:", this.selectedProject)
                //console.log("Projects in validation list:", this.getProjectsInValidationList)
                if(this.getProjectsInValidationList)return this.getProjectsInValidationList.filter(p => p.project_id === this.selectedProject);
                /* else if (this.getProjectsInArchivedList)return this.getProjectsInArchivedList.filter(p => p.project_id === this.selectedProject);
                else if (this.getProjectsBackInEditionList)return this.getProjectsBackInEditionList.filter(p => p.project_id === this.selectedProject); */
            }
            if(status === "validation") {
                return this.getProjectsInValidationList
            }else if (status == "editing"){
                return this.getProjectsBackInEditionList
                //EDITING + HAS_EVALUATOR
                /* const idPastValidation = this.getProjectsBackInEditionList;
                return idPastValidation.map(project => {
                const detailed = this.projectData.find(p => p.project_id == project.project_id);
                //console.log("idPastValidation(numberProjects) : ", idPastValidation,  "\n", detailed, "\nhas_evaluator : ", detailed?.has_evaluator)
                return {
                    ...project,
                    has_evaluator: detailed ? detailed.has_evaluator : false
                };
            }).filter(p => p.has_evaluator == true); */
            } else if(status === "validated") {
                return this.getProjectsValidatedList
            } else if(status === "archive") {
                return this.getProjectsInArchivedList
                //ARCHIVE + HAS_EVALUATOR
                /* const idPastValidation = this.getProjectsInArchivedList;
                return idPastValidation.map(project => {
                const detailed = this.projectData.find(p => p.project_id == project.project_id);
                //console.log("this.projectDataArchived",this.projectData)
                //console.log("idPastValidation(numberProjects) : ", idPastValidation,  "\n", detailed, "\n", detailed?.has_evaluator)
                return {
                    ...project,
                    has_evaluator: detailed ? detailed.has_evaluator : false
                };
            }).filter(p => p.has_evaluator == true); */
            }else{
                //console.log("No status provided, returning all projects in :", status, "\n", this.getProjectsInValidationList, this.getProjectsValidatedList, this.getProjectsInArchivedList, this.getProjectsBackInEditionList, "\n'numberProjects'")
                if(this.getProjectsInValidationList.length > 0) {
                    return this.getProjectsInValidationList
                } else if(this.getProjectsValidatedList.length > 0) {
                    return this.getProjectsValidatedList
                } else if(this.getProjectsInArchivedList.length > 0) {
                    return this.getProjectsInArchivedList
                } else if(this.getProjectsBackInEditionList.length > 0){
                    return this.getProjectsBackInEditionList
                }else{
                    return []
                }
            }
        },
        deleteProject(project_id) {
          //console.log("Deleting project with id:", project_id, "\nDELETE ?????")
          this.$store.commit("project/returnConfirmationObjectMutation", { 
              id: project_id, 
              type: "delete-project",
              title: "Suppression",
              message: "Êtes-vous sûr de vouloir supprimer ce projet?",
              fromRef:true,
          })
        },
        changeProjectStatus(project_id, status) {
            //console.log("Changing project status for project", project_id, " to ", status)
            let title = ""
            let message = ""
            let fromRef = false;
            switch(status) {
                case "VALIDATION":
                    title = "Remise en évaluation"
                    message = "Êtes-vous sûr de vouloir remettre ce projet en évaluation ?"
                    break
                case "ARCHIVE":
                    title = "Archiver"
                    message = "Êtes-vous sûr de vouloir archiver ce projet ?"
                    fromRef = true;
                    break
                default:
                    title = "Remise en édition"
                    message = "Êtes-vous sûr de vouloir remettre ce projet en édition ?"
                    break
            }
            this.$store.commit("project/returnConfirmationObjectMutation", { 
                id: project_id, 
                type: "project-change-status",
                title: title,
                message: message,
                newStatus: status,
                status: this.releaseStatus,
                fromRef: fromRef
            })
        },
        /* canDeleteProject(project) {
            const detailedProject = this.projectData.find(p => p.project_id === project.project_id);
            if(this.isAdmin)return true;
            if (!detailedProject)return false;
            //console.log("detailedProject :", detailedProject, "\nthis.isAdmin : ",this.isAdmin, "\ndetailedProject.is_owner :",detailedProject.is_owner)
            if (detailedProject.is_owner)return true;
            return false;
        }, */
    },
};
</script>

<style scoped>
.container {
    padding: 2rem;
    background-color: var(--bg-color);
  }
  
  
  :deep(.p-datatable){
    border-radius: 8px;
  }
  
  :deep(.p-datatable-header-cell){
      padding: 5px 0px 12px 0;
      margin:5vh;
  }
  
  :deep(.p-datatable-tbody){
      padding-top: 15px;
  }
  
  :deep(.p-datatable-tbody > tr > td){
      padding: 12px 6px 10px 1px;
      border-bottom: 1px solid transparent !important;
      border-top: 1px solid transparent !important;
  }
  
  :deep(.p-datatable-tbody > tr){
      border: none !important;
  }
  
  :deep(.p-datatable-tbody > tr:hover) {
      background-color: var(--hover-bg);
      transition: all 0.3s ease;
  }
  
  :deep(.p-datatable-tbody > tr:hover > td) {
      border-bottom: 1px solid black !important;
      border-top: 1px solid black !important;
  }
  
  :deep(.p-datatable-thead > tr > th) {
      font-weight: 600;
  }
  
  input[type="checkbox"] {
    transform: scale(1.2);
    cursor: pointer;
  }
  
  .p-inputtext-sm {
    width: 100%;
    max-width: 800px;
    padding: 0.75rem;
    border-radius: 6px;
    border: 2px solid #dee2e6;
  }
  
  .card.flex {
      box-shadow: none;
  }
  
  .p-inputtext-sm:focus {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.25);
    border-radius: var(--border-radius);
  }
  
  :deep(.p-datatable-paginator-bottom){
      border: none;
      padding: 3vh 0 0 0;
  }
  
  :deep(.p-paginator-content){
      gap: 2vw;
      text-align:center;
  }
  .bi-shield-fill{
    color:var(--left3-color);
    margin-left: 0.3vw;
  }

  /* Project list styles (similar to referentialEditor.vue) */
.project-list-header, .project-item {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    align-items: center;
}
.project-list-header {
    font-weight: bold;
    padding: 12px 15px;
    margin-bottom: 12px;
}
.project-list {
    background-color: #f8f9fa;
    padding: 8px;
    border-radius: var(--border-radius);
}
.project-item {
    padding: 20px 4px;
    border: 2px solid #e9ecef;
    border-radius: 12px;
    cursor: pointer;
    margin-bottom: 12px;
    background-color: var(--bg-color);
    transition: border 0.2s, background 0.2s;
}
.project-item:hover {
    background-color: var(--hover-bg);
    border-left: 7px solid var(--primary-color);
    border: 2px solid var(--primary-color);
}
.project-title-col {
    padding: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
}
.back-button {
    margin-top: 2rem;
    background-color: #f8f9fa;
    color: var(--text-color);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
    padding: 10px 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}
/* buttons */
.project-item:has(.actions-col) {
    grid-template-columns:28% 50% 22% ;
    margin-bottom: 1vh;
    border: 2px solid white;
    transition: all 0.2s ease;
    background-color: var(--bg-color);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
@media only screen and (min-width: 768px) and (max-width: 1400px) {
    .project-item:has(.actions-col) {
        grid-template-columns: 28% 40% 32%;
    }
}

.active{
  color: var(--primary-color);
  background: var(--primary-light);
  font-weight: 600;
}

.action-buttons, .filter-toggle {
    display: flex;
    justify-content: center;
    margin: 20px 0;
}
.action-buttons .projects-after-validation-col {
    background-color: rgb(245, 243, 243);
    /* color: rgb(0, 0, 0); */
    /* border: none; */
    border-radius: var(--border-radius);
    padding: 10px 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    margin:0 0.3vw;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

</style>